import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import CardsLeftImage from './../block/CardsLeftImage'
import Cards1 from './../block/Cards1'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class Ekonom extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <Cards1
          title={`Окна эконом-класса <span>от производителя</span>`}
          rtext={`[Надежность каждого окна]`}
          text={`Окна Эконом - это отличный вариант для всех, кто планирует выгодно остеклить дачу, беседку или балкон. Окна изготавливаются из двухслойного<br />клееного бруса и содержат однокамерный стеклопакет.`}
          list={data?.cards1?.list || []}
          cols={1}
          margin={`top`}
          bg={2}
          layout={6}
        />
        <CardsLeftImage
          list={data?.cards_left_image}
          assets_path={assets_path}
          className={`y`}
          title={`Стоимость окон <span>эконом</span>`}
          rtext={2}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Ekonom.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Ekonom.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Ekonom